<template>
  <div class="m-checkout-comments">
    <base-textarea
      v-model="localComment"
      type="text"
      :label="$t('checkoutCommentsLabel', 'Kommentar:')"
      name="checkout-comment"
      aria-label="Indtast kommentar"
      class="-checkout-comment"
      maxlength="500"
    />
  </div>
</template>

<script>
import BaseTextarea from '@/components/atoms/BaseTextarea.vue';

export default {
  name: 'CheckoutComments',
  inject: ['$validator'],
  components: {
    BaseTextarea
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    localComment: {
      get () {
        return this.value;
      },
      set (localComment) {
        this.$emit('input', localComment);
      }
    }
  }
}
</script>
